import React, { useState } from 'react';
import { useAuth } from "react-oidc-context";
import styles from './TermsOfService.module.sass';
import { updateTos } from 'services/user';
import { toast } from 'react-toastify';

const TermsOfServiceModal = ({ isOpen, onClose, onAccept }) => {
  const [isAgreed, setIsAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const auth = useAuth();
  
  if (!isOpen) return null;

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  const handleCheckboxChange = (e) => {
    setIsAgreed(e.target.checked);
  };

  const handleAccept = async () => {
    if (isAgreed && auth.user?.profile?.['cognito:username']) {
      setIsSubmitting(true);
      try {
        if (!auth.user?.access_token) {
          toast.error('User not authenticated');
          return;
        }
        
        const success = await updateTos(
          auth.user.profile['cognito:username'], 
          auth.user.access_token
        );
        if (success) {
          onAccept();
          onClose();
        }
      } catch (error) {
        console.error('Failed to update terms of service');
      } finally {
        setIsSubmitting(false);
      }
    }
  };


  return (
    // <div className={styles.modalOverlay} onClick={onClose}>
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} onClick={handleModalClick}>
      <div className={styles.modalHeader}>
          <h2>Terms of Service - Astrotek</h2>
          {/* <button className={styles.closeButton} onClick={onClose}>
            <X size={24} />
          </button> */}
        </div>
        
        <div className={styles.modalBody}>
          <div className="space-y-6">
            <div>
              <p><strong>Last Updated:</strong> April 8, 2025</p>
              {/* <p>These Terms of Service (the "Terms") form a binding agreement between you ("you" or "User") and Astrotek Labs LLC, a Georgia limited liability company with a principal place of business at 305 Trilith Pkwy Ste 300, PMB 1629, Fayetteville, GA 30214 ("Astrotek," "we," "us," or "our"), governing your access to and use of our websites, APIs, data analytics tools, and all other software, documentation, or services (collectively, the "Service").</p> */}
              <p>These Terms of Service (the "Terms") form a binding agreement between you ("you" or "User") and Astrotek Labs LLC ("Astrotek," "we," "us," or "our"), governing your access to and use of our websites, APIs, data analytics tools, and all other software, documentation, or services (collectively, the "Service").</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Eligibility and Acceptance</h3>
              <p>You represent and warrant that you are of the legal age of majority in your jurisdiction of residence (at least 18 in most U.S. states), that you have the full right, power, and authority to enter into and comply with these Terms, and that any registration information you submit is truthful and accurate. We may revise these Terms at any time by posting a revised version, with the revised version becoming effective upon posting.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Service Description</h3>
              <p>Astrotek provides data analytics, insights, and informational tools relating to digital assets, cryptocurrencies, blockchain networks, and related ecosystem metrics. The Service may include aggregated datasets, forward-looking analytics, historical snapshots, research content, and artificial intelligence–driven features designed to assist users in understanding and evaluating various digital assets.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Not Financial Advice</h3>
              <p>Astrotek is not a registered broker-dealer, exchange, investment advisor, or financial planner, and nothing in the Service constitutes investment, legal, or tax advice. Any and all decisions relating to the purchase, sale, transfer, or holding of digital assets are made solely by you. You understand that digital assets can be volatile, unregulated, or subject to substantial risk.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Accounts and Security</h3>
              <p>You may be required to create an account to access certain features. You agree to provide true, current, and complete information during registration and maintain the confidentiality of your login credentials. You are solely responsible for all activities through your account and must promptly notify us of any unauthorized use.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">License and Proprietary Rights</h3>
              <p>Subject to your compliance with these Terms, Astrotek grants you a limited, non-exclusive, non-transferable, revocable license to access and use the Service for your internal or personal use only. All content, source code, design elements, and other materials remain exclusively owned by Astrotek or its licensors.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Usage Restrictions</h3>
              <p>You agree to use the Service lawfully and in compliance with these Terms. You will not engage in any activity that could damage or impair the Service's functionality, attempt to reverse engineer the Service, or use the Service to facilitate illegal conduct, money laundering, or fraudulent activity.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Fees and Payment</h3>
              <p>If you subscribe to any fee-based version of the Service, you agree to pay all applicable fees. Astrotek may automatically charge your payment method on a recurring basis unless you properly cancel your subscription. You are responsible for keeping billing information current.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Data Accuracy and Third-Party Content</h3>
              <p>Information available through the Service may be derived from third-party sources that may be incomplete, outdated, or inaccurate. Astrotek does not guarantee the reliability, timeliness, or completeness of such information and shall not be liable for decisions resulting from your reliance on that information.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Privacy and Confidentiality</h3>
              <p>Your data will be handled in accordance with our Privacy Policy. Any non-public information about Astrotek's business operations or technical processes shall be deemed confidential and must not be disclosed to third parties without our express consent.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Disclaimer of Warranties</h3>
              <p>THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTY OF ANY KIND. TO THE MAXIMUM EXTENT PERMITTED BY LAW, ASTROTEK DISCLAIMS ALL WARRANTIES, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Limitation of Liability</h3>
              <p>TO THE FULLEST EXTENT PERMITTED BY LAW, ASTROTEK SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE, OR EXEMPLARY DAMAGES. OUR TOTAL CUMULATIVE LIABILITY SHALL NOT EXCEED THE GREATER OF $100 USD OR THE TOTAL FEES PAID BY YOU IN THE SIX MONTHS PRECEDING THE CLAIM.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Indemnification</h3>
              <p>You shall indemnify and hold harmless Astrotek from any claims, liabilities, damages, or expenses arising out of your breach of these Terms, your use of the Service, your violation of any law, or any infringement of intellectual property rights.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Termination</h3>
              <p>Astrotek may suspend or terminate your access at any time, with or without notice, if you violate these Terms or present an unacceptable risk. You may terminate by ceasing use of the Service and cancelling your subscription. Sections intended to survive termination shall continue in effect.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Governing Law and Arbitration</h3>
              <p>These Terms are governed by Georgia law. Any disputes shall be resolved by binding arbitration administered by JAMS in Atlanta, Georgia. Both parties waive the right to a trial by jury or to participate in a class action lawsuit.</p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">Contact Information</h3>
              <p>For questions regarding these Terms, contact us at:</p>
              <p>Astrotek Labs LLC<br/>
              Email: info@astrotek.app<br/>
              {/* , a Georgia limited liability company with a principal place of business at 305 Trilith Pkwy Ste 300, PMB 1629, Fayetteville, GA 30214</p> */}
              Principal Place of Business: 305 Trilith Pkwy Ste 300, PMB 1629, Fayetteville, GA 30214</p>
            </div>

            <div>
              <p>By accessing or using the Service, you acknowledge that you have read, understand, and agree to be bound by these Terms and all applicable laws.</p>
            </div>

          </div>
        </div>
        <div className={styles.modalFooter}>
          <div className={styles.agreementSection}>
            <div className={styles.checkboxContainer}>
              <input
                type="checkbox"
                id="terms-agree"
                checked={isAgreed}
                onChange={handleCheckboxChange}
                className={styles.checkbox}
              />
              <label htmlFor="terms-agree" className={styles.checkboxLabel}>
                I have read and agree to the Terms of Service
              </label>
            </div>
            
            <div className={styles.buttonGroup}>
              {/* <button
                onClick={onClose}
                className={styles.cancelButton}
                disabled={isSubmitting}
              >
                Cancel
              </button> */}
              <button
                onClick={handleAccept}
                disabled={!isAgreed || isSubmitting}
                className={`${styles.acceptButton} ${(!isAgreed || isSubmitting) ? styles.disabled : ''}`}
              >
                {isSubmitting ? 'Accepting...' : 'Accept Terms'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default TermsOfServiceModal;